import { BoxProps, Box as MuiBox, styled } from "@mui/material";
import { spacing } from "@mui/system";

const BoxRaw = styled(MuiBox)(spacing);

export const Box: React.FC<BoxProps> = (props) => <BoxRaw {...props} />;
